import axios from '@/axios/api.request'

export const save = (form) => axios.request({
    url: '/contract/invoice/info/save',
    data: form,
    method: 'post'
  })

export const remove = (id) => axios.request({
    url: `/contract/invoice/info/delete/${id}`,
    method: 'delete'
  })

  export const batchSave = (form) => axios.request({
    url: '/contract/invoice/info/batchSave',
    data: form,
    method: 'post'
  })

  export const receive = (form) => axios.request({
    url: '/contract/invoice/info/receive',
    data: form,
    method: 'post'
  })